export default __webpack_public_path__ + "static/media/img1.df6cbe5b.svg";